<template>
  <div style="">
    <el-row>
      <span >
        <el-button type="text" @click="add">Add New <i class="fas fa-plus-square"/></el-button>
        <el-input v-debounce="getAll" :debounce-events="'keydown'" v-model="term" size="small" type="text" placeholder="search" style="width: 40em" ><i slot="suffix" class="el-input__icon el-icon-search"/></el-input>
      </span>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="benefits"
          border
          style="width: 100%">
          <el-table-column prop="name" label="Name" />
          <el-table-column prop="desc" label="Description" />
          <el-table-column prop="type" label="Type" />
          <el-table-column prop="code" label="UACS Code" />
          <el-table-column label="Tax type" align="center">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.label === 1 && scope.row.type === 'others'"
                key="True"
                type="primary"
                size="small"
                effect="dark">
                De Minimis
              </el-tag>
              <el-tag
                v-if="scope.row.label === 2 && scope.row.type === 'others'"
                key="True"
                type="warning"
                size="small"
                effect="dark">
                Taxable
              </el-tag>
              <el-tag
                v-if="scope.row.label === 3 && scope.row.type === 'others'"
                key="True"
                type="danger"
                size="small"
                effect="dark">
                90k Pool
              </el-tag>
              <el-tag
                v-if="scope.row.label === 0"
                key="False"
                type="success"
                size="small"
                effect="dark">
                Default
              </el-tag>
              <br>
              <!--span v-if="scope.row.tag" style="font-size: 11px; color: red">Different computation of Tax deduction</span-->
            </template>
          </el-table-column>
          <!--el-table-column prop="paymentType" label="Payment Type" align="center" /-->
          <el-table-column prop="amount" label="Amount" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.amount">
                {{ Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Action">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="edit(scope.row)" ><i class="fas fa-file-invoice"/>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
        </div>
      </el-col>
    </el-row>
    <el-dialog v-if="selected" :visible.sync="editable" :title="title" width="50%" center >
      <el-form ref="selected" :model="selected" label-position="top">
        <el-form-item label="UACS Code" prop="code">
          <el-input
            v-model="selected.code"
            placeholder="Please input code here"
            clearable />
        </el-form-item>
        <el-form-item label="Benefit Name" prop="name">
          <el-input
            v-model="selected.name"
            placeholder="Please input"
            clearable />
        </el-form-item>
        <el-form-item label="Description" prop="desc">
          <el-input
            v-model="selected.desc"
            placeholder="Please input"
            clearable />
        </el-form-item>
        <el-form-item label="Type" prop="desc">
          <el-select v-model="selected.type" placeholder="Select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item v-if="selected.type === '3'" prop="label">
          <el-radio-group v-model="selected.label">
            <el-radio :label="1">De Minimis</el-radio>
            <el-radio :label="2">Taxable</el-radio>
            <el-radio :label="3">90k Pool</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="selected.label === 1" label="Maximum amount" prop="amount">
          <el-input
            v-model="selected.amount"
            type="number"
            placeholder="Please input amount here"
            clearable />
        </el-form-item>
        <div>
          <!--p><el-checkbox v-model="tag">Different computation of Tax deduction</el-checkbox></p-->
          <p><el-checkbox v-model="tag">Generate Multiple Report in a Month</el-checkbox></p>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editable = false">Cancel</el-button>
        <el-button type="primary" @click="save()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Benefits } from '@/api/payroll/benefits'
import { Notification } from 'element-ui'
export default {
  name: 'Benefits',
  data() {
    return {
      tag: false,
      loading: false,
      meta: {
        page: 1
      },
      term: '',
      benefits: [],
      editable: false,
      selected: null,
      options: [
        {
          value: '1',
          label: 'Default'
        },
        {
          value: '2',
          label: 'Not taxable'
        },
        {
          value: '3',
          label: 'Others'
        }
      ],
      ptype: [
        {
          value: '1',
          label: 'Yearly'
        },
        {
          value: '2',
          label: 'Monthly'
        },
        {
          value: '3',
          label: 'Quarterly'
        }
      ]
    }
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.editable = false
      this.selected = null
      this.loading = true
      Benefits({ term: this.term, page: this.meta.page }, 'get', '').then(res => {
        this.benefits = res.data.benefits
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    edit(index) {
      this.selected = Object.assign({}, index)
      if (this.selected.type === 'others') {
        this.selected.type = '3'
      }
      this.tag = this.selected.tag !== 0
      this.editable = true
      this.title = 'Edit Benefit'
    },
    add() {
      this.selected = {}
      this.title = 'New Benefit'
      this.editable = true
    },
    save: function() {
      this.selected.type === 3 || this.selected.type === '3' ? this.selected.label : this.selected.label = 0
      this.tag ? this.selected.tag = 1 : this.selected.tag = 0
      var action = this.selected.id ? 'patch' : 'post'
      Benefits(this.selected, action).then(res => {
        Notification.success({
          title: 'Success',
          message: 'Benefit has been saved successfully',
          duration: 4 * 1000
        })
        this.getAll()
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>

</style>
